module.exports = __webpack_public_path__ + "img/step01_a_stand_power_remove_film_cut_straps - Copy.6809a4c1.png";